<template>
  <div>
  <!-- Table Container Card -->
    <b-card no-body class="mb-0">
      <div class="row m-2">
        <!-- Left column -->
        <div class="col-md-6">
          <div class="form-group row">
            <label class="col-sm-3 col-form-label">MiME ID</label>
            <div class="col-sm-8">
              <b-form-input
                type="text"
                class="form-control"
                :value="customer.username || ''"
                readonly
                placeholder="Subscriber ID"
              />
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-3 col-form-label">Name</label>
            <div class="col-sm-8">
              <b-form-input
                type="text"
                class="form-control"
                :value="fullName"
                readonly
                placeholder="Subscriber Name"
              />
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-3 col-form-label">Billing Scheme</label>
            <div class="col-sm-8">
              <b-form-input
                type="text"
                class="form-control"
                :value="customer.billing_scheme || ''"
                readonly
              />
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-3 col-form-label">Contact No.</label>
            <div class="col-sm-8">
              <b-form-input
                type="text"
                class="form-control"
                :value="customer.mobile_primary || ''"
                readonly
              />
            </div>

            <label class="col-sm-3 col-form-label">&nbsp;</label>
            <div class="col-sm-8 pt-2">
              <b-form-input
                type="text"
                class="form-control"
                :value="customer.mobile_optional || ''"
                placeholder="Optional Contact No."
                readonly
              />
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-3 col-form-label">Email</label>
            <div class="col-sm-8">
              <b-form-input
                type="email"
                class="form-control"
                :value="customer.email || ''"
                readonly
              />
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-3 col-form-label">Date of Birth</label>
            <div class="col-sm-8">
              <div class="input-group">
                <b-form-input class="form-control" :value="formattedDob" readonly />
              </div>
            </div>
          </div>
        </div>

        <!-- Right column -->
        <div class="col-md-6">
          <div class="form-group row">
            <label class="col-sm-3 col-form-label"
              >Profile Picture <span style="color: red">*</span></label
            >
            <div class="col-sm-4">
              <div v-if="previewImage">
                <img :src="previewImage" style="height: 7.1rem" />
              </div>
              <div v-else-if="customer.profile_pic">
                <img :src="customer.profile_pic" style="height: 7.1rem" />
              </div>
              <div v-else>No image available</div>
              <b-form-file
                accept="image/*"
                @change="onImageChange"
                class="mt-2"
              ></b-form-file>
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-3 col-form-label">Installation Address</label>
            <div class="col-sm-8">
              <b-form-textarea
                id="installation-address"
                :value="installationAddress"
                class="form-control"
                rows="3"
                disabled
                no-resize
                readonly
              ></b-form-textarea>
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-3 col-form-label">Billing Address</label>
            <div class="col-sm-8">
              <b-form-textarea
                id="billing-address"
                :value="billingAddress"
                class="form-control"
                rows="3"
                disabled
                no-resize
                readonly
              ></b-form-textarea>
            </div>
          </div>
        </div>
      </div>
      <b-row class="mt-2 mb-3">
        <b-col md="12" class="d-flex justify-content-center" style="margin-top: 1.5rem">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-1"
            @click="uploadProfilePic"
            :disabled="loading"
          >
            Update
          </b-button>
        </b-col>
      </b-row>
    </b-card>

    <b-card class="mb-0 mt-2">
      <h5 class="mb-1 font-weight-bold">Upload Document</h5>

      <validation-observer ref="formDocumentRules">
      <b-form @submit.prevent="uploadDocument">
        <b-row>
          <!-- Document Title -->
          <b-col md="6">
            <b-form-group label="Document Title *">
              <validation-provider
                    #default="{ errors }"
                    name="Document Title"
                    rules="required"
                  >
                    <b-form-select
                      v-model="documentForm.title"
                      :options="documentOptions"
                    />
              <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
              <span class="text-danger text-sm" v-if="be_errors['title']">
                <small>{{ be_errors["title"][0] }}</small>
              </span>
            </b-form-group>
          </b-col>

          <!-- File Upload -->
          <b-col md="6">
            <b-form-group label="Browse File *">

              <div
                class="border rounded d-flex flex-column justify-content-center align-items-center"
                style="height:150px; border-style:dashed; cursor:pointer;"
                @click="$refs.fileInput.click()"
              >
                <input
                  type="file"
                  ref="fileInput"
                  class="d-none"
                  @change="onFileChange"
                />

                <div class="text-center">
                  <i class="fa fa-cloud-upload fa-2x text-primary mb-2"></i>

                  <p class="text-muted">
                    {{ documentForm.fileName || "Drop file or click to upload" }}
                  </p>

                  <small class="text-muted">
                    Images (JPG, PNG) & PDF • Max 2MB
                  </small>
                </div>
              </div>

              <!-- ✅ Manual error message -->
              <small class="text-danger" v-if="fileError">
                {{ fileError }}
              </small>

            </b-form-group>
          </b-col>

        </b-row>

        <b-row class="mt-2">
          <b-col md="12" class="d-flex justify-content-center" style="margin-top: 1.5rem">
            <b-button variant="primary" type="submit" :disabled="uploading">
              {{ uploading ? "Uploading..." : "Upload" }}
            </b-button>
          </b-col>
        </b-row>
      </b-form>
      </validation-observer>
    </b-card>
    <b-card class="mt-2">
    <h5 class="mb-3 font-weight-bold">Uploaded Documents</h5>

    <b-table
      :items="documents"
      :fields="docFields"
      responsive
      show-empty
      empty-text="No documents uploaded yet."
    >
      <template #cell(created)="data">
        {{ data.item.created }}
      </template>

      <template #cell(actions)="data">
        <b-button
          size="sm"
          variant="info"
          @click="downloadFile(data.item)"
        >
          Download
        </b-button>
      </template>
    </b-table>
  </b-card>

  </div>
</template>

<script>
import {
  BCard,
  BForm,
  BRow,
  BCol,
  BFormInput,
  BFormTextarea,
  BFormFile,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BFormCheckbox,
  BFormSelect,
  BFormGroup,
  BSpinner,
} from "bootstrap-vue";
import api from "@/services/api";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Ripple from "vue-ripple-directive";
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
extend("required", required);
import { decrypt } from "@/utils/crypto";
import dayjs from "dayjs";


export default {
  name: "Details",
  components: {
    BCard,
    BForm,
    BRow,
    BCol,
    BFormInput,
    BFormTextarea,
    BFormFile,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BFormCheckbox,
    BFormSelect,
    BFormGroup,
    BSpinner,
    ToastificationContent,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      customer: {},
      loading: false,
      error: null,
      selectedImage: null,
      previewImage: null,

      documentForm: {
          title: "",
          file: null,
          fileName: "",
        },
      fileError: "", // ✅ add this
      be_errors: {},
      documentOptions: [
        { value: "", text: "Select Document" },
        { value: "NID Front", text: "NID Front" },
        { value: "NID Back", text: "NID Back" },
      ],

      documents: [],
      uploading: false,

      docFields: [
        { key: "title", label: "Title" },
        { key: "name", label: "File Name" },
        { key: "created", label: "Upload Date" },
        { key: "actions", label: "Actions" },
      ],

    };
  },
  computed: {
    fullName() {
      const { salutation = "", first_name = "", middle_name = "", last_name = "" } =
        this.customer || {};
      return [salutation, first_name, middle_name, last_name].filter(Boolean).join(" ");
    },
    formattedDob() {
      return this.customer.dob ? dayjs(this.customer.dob).format("YYYY-MM-DD") : "";
    },
    installationAddress: {
      get() {
        const addr = this.customer.detail_contact_address || {};
        const parts = [
          addr.address,
          addr.area,
          addr.district,
          addr.division,
          addr.location_input || addr.location,
        ];
        return parts.filter(Boolean).join(", ");
      },
      set() {}, // Empty setter since this is read-only
    },
    billingAddress: {
      get() {
        const addr = this.customer.detail_billing_address || {};
        const parts = [
          addr.address,
          addr.area,
          addr.district,
          addr.division,
          addr.location_input || addr.location,
        ];
        return parts.filter(Boolean).join(", ");
      },
      set() {}, // Empty setter since this is read-only
    },
  },
  methods: {
    async fetchCustomerInfo() {
      this.loading = true;
      this.error = null;
      const userData = decrypt(localStorage.getItem("userData"));
      const username = userData ? userData.username : null;
      if (!username) {
        this.error = "No username found in localStorage.";
        this.loading = false;
        return;
      }
      try {
        const response = await api.get(`/selfcare/api/v1/customer/${username}/`);
        if (response.data) {
          this.customer = response.data;
        } else {
          this.error = "No customer data found";
        }
      } catch (err) {
        this.error = err.message || "Error fetching service info";
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.error,
            icon: "AlertCircleIcon",
            variant: "danger",
          },
        });
      } finally {
        this.loading = false;
      }
    },
    onImageChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.selectedImage = file;
        this.previewImage = URL.createObjectURL(file);
      } else {
        this.selectedImage = null;
        this.previewImage = null;
      }
    },
    async uploadProfilePic() {
      if (!this.selectedImage) return;
      const loader = this.$showCustomLoader();
      this.loading = true;
      this.error = null;
      try {
        // Prepare FormData for file upload
        const formData = new FormData();
        formData.append("profile_pic", this.selectedImage);
        formData.append("username", this.customer.username || "");
        // Use username from customer object
        const username = this.customer.username;
        const response = await api.patch(
          `/api/v1/customer/${username}/`,
          formData
        );
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Success",
            text: "Profile picture updated!",
            icon: "CheckIcon",
            variant: "success",
          },
        });
        // Update customer profile_pic with new image
        if (response.data && response.data.profile_pic) {
          this.customer.profile_pic = response.data.profile_pic;
          this.previewImage = null;
          this.selectedImage = null;
        }
      } catch (err) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: err.response?.data?.message || err.message || "Upload failed.",
            icon: "AlertCircleIcon",
            variant: "danger",
          },
        });
      } finally {
        this.loading = false;
        loader.hide();
      }
    },

    onFileChange(e) {
      const file = e.target.files[0];
      if (!file) return;

      const allowedTypes = ["image/jpeg", "image/png", "application/pdf"];

      if (!allowedTypes.includes(file.type)) {
        this.$bvToast.toast("Only JPG, PNG, PDF allowed", {
          variant: "danger",
          solid: true,
        });

        this.$refs.fileInput.value = null;
        this.documentForm.file = null; // গুরুত্বপূর্ণ
        return;
      }

      if (file.size > 2 * 1024 * 1024) {
        this.$bvToast.toast("Max file size is 2MB", {
          variant: "danger",
          solid: true,
        });

        this.$refs.fileInput.value = null;
        this.documentForm.file = null; // গুরুত্বপূর্ণ
        return;
      }

      // ✅ Set value
      this.documentForm.file = file;
      this.documentForm.fileName = file.name;
    },

    async uploadDocument() {
      const isValid = await this.$refs.formDocumentRules.validate();
      if (!this.documentForm.file) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Failed",
            text: "Please select a file to upload.",
            icon: "AlertCircleIcon",
            variant: "danger",
          },
        });
        return;
      }

      if (!isValid) return;

      const loader = this.$showCustomLoader();
      const userData = decrypt(localStorage.getItem("userData"));
      const profileid = userData.profile_id;

      try {
        const formData = new FormData();
        formData.append("customer", profileid);
        formData.append("title", this.documentForm.title);
        formData.append("file", this.documentForm.file);

        await api.post("/customer/files/", formData);

        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Success",
            text: "Document uploaded successfully!",
            icon: "CheckIcon",
            variant: "success",
          },
        });

        this.resetForm();
        this.fetchDocuments();

      } catch (err) {
        this.$bvToast.toast(
          err.response?.data?.message || "Upload failed",
          { variant: "danger", solid: true }
        );
      } finally {
        loader.hide();
      }
    },

    toBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
      });
    },

    async fetchDocuments() {
      try {
        const userData = decrypt(localStorage.getItem("userData"));
        const profileid = userData ? userData.profile_id : null;

        const res = await api.get(`/customer/files/?customer=${profileid}`);
        this.documents = res.data.results || [];
      } catch (err) {
        console.error(err);
      }
    },

    async downloadFile(item) {
      try {
        const loader = this.$showCustomLoader();
        const response = await fetch(item.link);
        const blob = await response.blob();

        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", item.name || "file");

        document.body.appendChild(link);
        link.click();

        link.remove();
        window.URL.revokeObjectURL(url);
        loader.hide();


      } catch (error) {
        console.error(error);
        this.$bvToast.toast("Download failed", {
          variant: "danger",
          solid: true,
        });
      }
    },

    resetForm() {
      // ✅ reset vee-validate form
      this.$refs.formDocumentRules.reset();

      // ✅ reset model
      this.documentForm.title = "";
      this.documentForm.file = null;
      this.documentForm.fileName = "";

      // ✅ reset file input (important)
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = null;
      }

      // ✅ clear manual error যদি থাকে
      this.fileError = "";
    }

  },
  mounted() {
    this.fetchCustomerInfo();
    this.fetchDocuments();
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

// Style for disabled textareas
::v-deep .form-control[disabled] {
  background-color: #f8f9fa;
  opacity: 1;
  cursor: not-allowed;
}
</style>
